import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../App/redux/store';
import { getModalsState, modalsActions } from '../features/modals/modalsSlice';
import NavIcons from './NavIcons';

const NavLine = ({ activeNav, navName, path }) => {
  const { mobileNav } = useAppSelector(getModalsState);
  const dispatch = useAppDispatch();

  const handleClick = () => {
    if (mobileNav) {
      dispatch(modalsActions.mobileNav(false));
    }
  };

  return (
    <li
      key={navName}
      className={activeNav === path ? 'active-nav' : ''}
      onClick={handleClick}
    >
      <Link to={path}>
        <NavIcons title={navName} />
        {navName}
      </Link>
    </li>
  );
};

NavLine.propTypes = {
  activeNav: PropTypes.string.isRequired,
  navName: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default NavLine;
